import { adminHttpClient } from '../../../../../commons/adminHttpClient'
import { NamedItem } from '../../../../../../domain/common/namedItem'

export type PerksCategoriesWithExpenseResponse = {
  id: number
  name: string
  isCustom: boolean
  expenseTypes: ExpenseTypeResponse[]
}

type ExpenseTypeResponse = NamedItem & {
  isCustom: boolean
}

export const getCategoriesWithExpenseTypes = (
  productId: string,
  planPeriodId: string,
): Promise<PerksCategoriesWithExpenseResponse[]> => {
  return adminHttpClient.get(`/AdminDashboard/Perks/ClassDesign/CategoriesWithExpenseTypes/${productId}`, {
    planPeriodId,
  })
}
